import React, { useMemo } from 'react'
import StoriesFormFields from '../StoriesFormFields'
import { useTranslation } from 'react-i18next'

import useLineItemDetails from '../../../../hooks/useLineItemDetails'

import useStyles from '../../../ItemForm/styles'

const SingleStory = ({ formik, showError, isStepFieldsValid }) => {
  const { t } = useTranslation()
  const classes = useStyles({})

  const { isVideoViews } = useLineItemDetails()

  const storyFormTitle = useMemo(() => (isVideoViews ? 'video' : 'image or video'), [isVideoViews])

  return (
    <div className={classes.carouselItemForm}>
      <div className={classes.title}>{t(storyFormTitle)}</div>
      <StoriesFormFields
        index={0}
        isItemActive={true}
        isStepFieldsValid={isStepFieldsValid}
        formik={formik}
        showError={showError}
      />
    </div>
  )
}

export default SingleStory
